export const DEFAULT_PAYMENT_DASHBOARD_VIEW_ROLES = ["super_admin"];

export const TECH_DASHBOARD_VIEW_ROLES = [
  "super_admin",
  "admin",
  "sleep_technician",
];

export const TECH_DASHBOARD_SELF_SCOPE_ROLES = [
  "admin",
  "sleep_technician",
];

const normalizeProviderName = (value) => String(value || "").trim();

export const hasPaymentDashboardViewRole = (
  currentRoles,
  allowedViewRoles = DEFAULT_PAYMENT_DASHBOARD_VIEW_ROLES,
) =>
  Array.isArray(currentRoles) &&
  Array.isArray(allowedViewRoles) &&
  allowedViewRoles.some((role) => currentRoles.includes(role));

export const canViewPaymentDashboard = (
  currentRoles,
  canManagePayments,
  allowedViewRoles = DEFAULT_PAYMENT_DASHBOARD_VIEW_ROLES,
) =>
  Boolean(canManagePayments) ||
  hasPaymentDashboardViewRole(currentRoles, allowedViewRoles);

export const canManageOwnTechnicianPayments = ({
  currentRoles,
  providerName,
}) =>
  Array.isArray(currentRoles) &&
  TECH_DASHBOARD_SELF_SCOPE_ROLES.some((role) => currentRoles.includes(role)) &&
  Boolean(normalizeProviderName(providerName));

export const canViewOwnTechnicianPaidCases = ({
  currentRoles,
  providerName,
}) =>
  Array.isArray(currentRoles) &&
  currentRoles.some((role) =>
    ["super_admin", ...TECH_DASHBOARD_SELF_SCOPE_ROLES].includes(role),
  ) &&
  Boolean(normalizeProviderName(providerName));

export const canEditTechnicianPendingBatch = ({
  canManagePayments,
  hasFullPaymentAccess,
  providerKey,
  batchTechKey,
  isConfirmed,
}) => {
  if (!canManagePayments || isConfirmed) return false;
  if (hasFullPaymentAccess) return true;

  const normalizedProviderKey = normalizeProviderName(providerKey);
  return (
    Boolean(normalizedProviderKey) &&
    normalizedProviderKey === normalizeProviderName(batchTechKey)
  );
};

export const getTechnicianDashboardScope = ({
  currentRoles,
  displayName,
  mappedProviderName,
  hasConfiguredPaymentAccess,
}) => {
  const roles = Array.isArray(currentRoles) ? currentRoles : [];
  const isSuperAdmin = roles.includes("super_admin");
  const hasConfiguredAccess = Boolean(hasConfiguredPaymentAccess);
  const requiresOwnScope =
    (isSuperAdmin && !hasConfiguredAccess) ||
    (!isSuperAdmin &&
      TECH_DASHBOARD_SELF_SCOPE_ROLES.some((role) => roles.includes(role)));
  const providerName =
    normalizeProviderName(mappedProviderName) ||
    (requiresOwnScope ? normalizeProviderName(displayName) : "");
  const hasFullPaymentAccess = hasConfiguredAccess && !requiresOwnScope;

  return {
    requiresOwnScope,
    providerName,
    hasFullPaymentAccess,
    canViewAllTechnicians: isSuperAdmin || hasFullPaymentAccess,
    canQueryAllTechnicianCases: hasFullPaymentAccess,
    canViewOwnTechnician: requiresOwnScope && Boolean(providerName),
  };
};
